import { Button, Paper, Typography } from '@mui/material'
import React from 'react'
import Container from '../../../common/container/Container'
import { getMonthName } from '../../../common/utils'
import { Mutation } from '../../../react-apollo/Components'
import { i18n } from '../../index'
import css from './incentiveProductPage.css'
import IncentiveSalesCorrectionFactorDialog from './IncentiveSalesCorrectionFactorDialog'
import {
  incentiveSalesCorrectionFactorQuery,
  upsertIncentiveSalesCorrectionFactorMutation,
} from './incentiveSalesCorrectionFactorsQueries'
import {
  IncentiveSalesCorrectionFactorInput,
  IncentiveSalesCorrectionFactorResponse,
} from './incentiveSalesCorrectionFactorTypes'

interface Props {
  correctionFactors: IncentiveSalesCorrectionFactorResponse[]
}

const monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

function getFactorValueByMonth(month: number, factors: ReadonlyArray<{ month: number; factor: number }>) {
  const factor = factors.find((f) => f.month === month)
  return factor ? factor.factor : '-'
}

export default function IncentiveSalesCorrectionFactors({ correctionFactors }: Props) {
  const [isAddNewFactorDialogOpen, setIsAddNewFactorDialogOpen] = React.useState(false)

  function onUpsertIncentiveSalesCorrectionFactor(onMutate: any, inputData: IncentiveSalesCorrectionFactorInput[]) {
    onMutate({
      variables: {
        data: {
          factors: inputData,
        },
      },
    })
    setIsAddNewFactorDialogOpen(false)
  }

  return (
    <Container className={css.componentMarginBottom20}>
      <Typography variant='h5'>{i18n.t('admin.incentiveSalesTargets.correctionFactorTitle')}</Typography>
      <Paper className={css.componentMarginBottom20}>
        <div className={css.componentMarginBottom20}>
          {correctionFactors.map((item: IncentiveSalesCorrectionFactorResponse) => (
            <div key={item.year}>
              <Typography variant='h6'>{item.year}</Typography>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 16%)' }}>
                {monthNumbers.map((month) => (
                  <span key={month}>
                    {getMonthName(month)}: {getFactorValueByMonth(month, item.factors)}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <Mutation
          mutation={upsertIncentiveSalesCorrectionFactorMutation}
          refetchQueries={[{ query: incentiveSalesCorrectionFactorQuery }]}
        >
          {(onMutate) => (
            <IncentiveSalesCorrectionFactorDialog
              isOpen={isAddNewFactorDialogOpen}
              onClose={() => setIsAddNewFactorDialogOpen(false)}
              onSave={(inputData: IncentiveSalesCorrectionFactorInput[]) => {
                onUpsertIncentiveSalesCorrectionFactor(onMutate, inputData)
              }}
              existingFactors={correctionFactors}
            />
          )}
        </Mutation>
      </Paper>
      <div className={css.editButtonRight}>
        <Button variant='contained' color='primary' onClick={() => setIsAddNewFactorDialogOpen(true)}>
          {i18n.t('admin.incentiveSalesTargets.correctionFactorEditButton')}
        </Button>
      </div>
    </Container>
  )
}
